<template>
  <div v-if="loading" class="skeleton-loader-wrapper">
    <SkeletonLoader :loadingText="loadingText" />
  </div>
  <div v-else>
    <div class="view user-data-view">
      <div class="ud-header">
        <h1 class="ud-title">Tell us about yourself</h1>
        <p class="ud-sub">Just a few quick details to get started.</p>
      </div>

      <form @submit.prevent="UpdateUserProfile">
        <div class="ud-section">
          <p class="ud-section-label">Your details</p>

          <div class="ud-field">
            <label class="ud-label" for="displayName">
              Name <span class="ud-hint">— what should we call you?</span>
            </label>
            <input
              id="displayName"
              type="text"
              class="ud-input"
              v-model="formData.displayName"
              placeholder="Your name or nickname"
            />
          </div>

          <div class="ud-field mt">
            <label class="ud-label" for="dob">
              Date of Birth <span class="ud-asterisk">*</span>
            </label>
            <input
              id="dob"
              type="date"
              class="ud-input date-picker"
              required
              v-model="formData.dateOfBirth"
            />
          </div>

          <div class="ud-field mt">
            <label class="ud-label" for="email">
              Email Address <span class="ud-asterisk">*</span>
            </label>
            <input
              id="email"
              type="email"
              class="ud-input"
              v-model="formData.email"
              autocomplete="email"
              required
            />
          </div>
        </div>

        <button
          role="button"
          type="submit"
          aria-label="submit update user profile"
          class="ud-submit"
          :disabled="!formData.dateOfBirth || formData.dateOfBirth === 0"
        >
          Next →
        </button>
      </form>
    </div>

    <ProgressBar
      :currentStep="1"
      :steps="4"
      :stepLabels="['Account Type', 'Your Details', 'Categories', 'All Done']"
    />
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import SkeletonLoader from '../../components/SkeletonLoader.vue';
import { useMyStore } from '../../store';
import ProgressBar from '../../components/ProgressBar.vue';

export default {
  components: { SkeletonLoader, ProgressBar },
  setup() {
    const store = useMyStore();
    const formData = ref({
      displayName: '',
      dateOfBirth: null,
      email: store.userInfo.email,
    });
    const router = useRouter();
    const loading = ref(true);
    let loadingText = ref('Loading...');
    const user = ref();

    const enterUserData = () => {
      router.push({ name: 'JuniorCategoryData' });
    };

    const UpdateUserProfile = () => {
      loadingText.value = 'Saving Account...';
      loading.value = true;

      try {
        let userData = {
          PreferredName: formData.value.displayName
            ? formData.value.displayName
            : formData.value.firstName,
          DateOfBirth: formData.value.dateOfBirth
            ? new Date(formData.value.dateOfBirth + 'T00:00:00').toISOString()
            : null,
          Email: formData.value.email,
          newUserLoginFlowComplete: true,
        };
        store.saveUserAccount(userData).then((response) => {
          if (response.status === 200) {
            store.getUserAccountData().then(() => {
              loading.value = false;
              router.push({ name: 'JuniorCategoryData' });
            });
          }
        });
      } catch (error) {
        loading.value = false;
        console.error('An error occurred:', error);
      }
    };

    onMounted(async () => {
      setTimeout(() => {
        const mainElement = document.querySelector('.main');
        if (mainElement) mainElement.scrollTo(0, 0);
      }, 100);
      user.value = store.user;
      loading.value = false;
    });

    return {
      formData,
      enterUserData,
      router,
      UpdateUserProfile,
      loading,
      loadingText,
    };
  },
};
</script>

<style scoped>
.user-data-view {
  max-width: 480px;
  margin: 0 auto;
}

.ud-header {
  text-align: center;
  padding: 1.75rem 0 0.25rem;
  margin-bottom: 1.5rem;
}

.ud-title {
  font-size: 1.3rem;
  font-weight: 700;
  color: #004751;
  margin: 0 0 0.3rem;
  letter-spacing: -0.02em;
}

.dark-theme .ud-title {
  color: #5dcaa5;
}

.ud-sub {
  font-size: 0.85rem;
  color: #888;
  margin: 0;
}

.ud-section-label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #7f77dd;
  margin: 0 0 0.75rem;
  padding-bottom: 0.4rem;
  border-bottom: 1.5px solid #eeedfe;
}

.dark-theme .ud-section-label {
  border-bottom-color: #2a2060;
}

.ud-hint {
  font-weight: 400;
  color: #aaa;
  font-size: 0.75rem;
}
</style>
